import { render, staticRenderFns } from "./RankData.vue?vue&type=template&id=c1545bda&scoped=true"
import script from "./RankData.vue?vue&type=script&lang=js"
export * from "./RankData.vue?vue&type=script&lang=js"
import style0 from "./RankData.vue?vue&type=style&index=0&id=c1545bda&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1545bda",
  null
  
)

export default component.exports